import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Archive } from "lucide-react";

export function ArchiveProjectDialog({ target, onClose, onConfirm, isPending }) {
  return (
    <Dialog open={!!target} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2" style={{ color: "var(--tga-amber)" }}>
            <Archive className="w-5 h-5" />
            Projekt archivieren
          </DialogTitle>
        </DialogHeader>
        <div className="py-2 space-y-3">
          <div className="p-3 rounded-lg" style={{ background: "var(--tga-amber-soft)", border: "1px solid rgba(245,158,11,0.2)" }}>
            <p className="text-sm font-medium" style={{ color: "var(--tga-amber)" }}>"{target?.name}" wird archiviert.</p>
            <p className="text-xs mt-1" style={{ color: "var(--tga-text-secondary)" }}>
              Das Projekt wird nicht mehr beim Einstempeln oder im Dashboard angezeigt, bleibt aber in der Historie erhalten.
            </p>
          </div>
          <p className="text-xs" style={{ color: "var(--tga-text-muted)" }}>
            Ein Admin kann archivierte Projekte jederzeit wiederherstellen.
          </p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="cancel-archive-btn">Abbrechen</Button>
          <Button
            onClick={() => onConfirm(target?.id)}
            disabled={isPending}
            style={{ background: "var(--tga-amber)", color: "#000" }}
            data-testid="confirm-archive-btn"
          >
            {isPending ? "..." : "Archivieren"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
